import { useState } from "react";
import InnerPageLayout from "../../components/feature/InnerPageLayout";

const positions = [
  {
    id: "builder-manager",
    title: "빌더 매니저",
    dept: "Operations",
    type: "정규직",
    loc: "서울 강남구",
    color: "#A855F7",
    glow: "rgba(168,85,247,0.12)",
    desc: "아티스트 파트너와 1:1로 매칭되어 비즈니스 빌딩 전 과정을 함께 이끌어가는 핵심 역할입니다.",
    tags: ["프로젝트 관리", "크리에이터 이코노미", "커뮤니케이션"],
    reqs: ["기획/PD/PM 3년 이상 경력", "크리에이터/예술 분야 이해도", "강한 책임감과 주도성"],
    headcount: "3명",
  },
  {
    id: "brand-designer",
    title: "브랜드 디자이너",
    dept: "Design",
    type: "정규직",
    loc: "서울 강남구 · 리모트 병행",
    color: "#14F1D9",
    glow: "rgba(20,241,217,0.12)",
    desc: "아티스트 IP를 세상에 선보일 브랜드 아이덴티티, 패키지, 디지털 자산을 설계합니다.",
    tags: ["Brand Identity", "Figma", "Typography"],
    reqs: ["브랜딩 에이전시 or 인하우스 3년 이상", "포트폴리오 필수 첨부", "한국어 타이포그래피 이해"],
    headcount: "2명",
  },
  {
    id: "fullstack-dev",
    title: "풀스택 개발자",
    dept: "Engineering",
    type: "정규직",
    loc: "서울 강남구 · 리모트 가능",
    color: "#F97316",
    glow: "rgba(249,115,22,0.12)",
    desc: "아티스트를 위한 D2C 커머스, 멤버십 플랫폼, 관리 대시보드를 설계하고 구축합니다.",
    tags: ["React", "Next.js", "Supabase", "TypeScript"],
    reqs: ["프론트엔드/백엔드 통합 개발 3년 이상", "사이드프로젝트 또는 스타트업 경험 우대", "빠른 MVP 빌드 경험"],
    headcount: "2명",
  },
  {
    id: "marketing-strategist",
    title: "마케팅 전략가",
    dept: "Marketing",
    type: "정규직 · 계약직",
    loc: "서울 강남구",
    color: "#C084FC",
    glow: "rgba(192,132,252,0.12)",
    desc: "아티스트 런칭 캠페인, SNS 전략, 팬덤 성장, 미디어 커버리지를 종합 기획합니다.",
    tags: ["Performance Marketing", "SNS 전략", "콘텐츠 기획"],
    reqs: ["디지털 마케팅 3년 이상", "엔터/문화예술 분야 경험 우대", "수치 기반 사고방식"],
    headcount: "2명",
  },
  {
    id: "legal-advisor",
    title: "IP 법무 자문",
    dept: "Legal",
    type: "파트타임 · 자문",
    loc: "원격",
    color: "#14F1D9",
    glow: "rgba(20,241,217,0.1)",
    desc: "아티스트 상표권/저작권 보호, 계약서 검토, 분쟁 대응을 담당합니다.",
    tags: ["IP 법", "저작권", "계약 검토"],
    reqs: ["변호사 자격증 보유", "IP/엔터테인먼트 법 전문", "스타트업 자문 경험 우대"],
    headcount: "1명",
  },
];

const benefits = [
  { icon: "ri-money-dollar-circle-line", color: "#A855F7", title: "성과 기반 인센티브", desc: "파트너 아티스트의 성장에 따라 팀원에게도 수익 쉐어 인센티브가 지급됩니다." },
  { icon: "ri-time-line", color: "#14F1D9", title: "자율 근무제", desc: "코어 타임 외 자유로운 시간 운영. 성과로 이야기하는 문화를 지향합니다." },
  { icon: "ri-book-open-line", color: "#F97316", title: "자기계발 지원", desc: "연간 200만원 교육비, 컨퍼런스/전시 참관비 전액 지원." },
  { icon: "ri-building-line", color: "#C084FC", title: "강남 오피스 + 리모트", desc: "서울 강남구 공용 오피스와 리모트를 유연하게 병행합니다." },
];

export default function CareersPage() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <InnerPageLayout>
      {/* Hero */}
      <section className="relative py-24 lg:py-40 px-4 md:px-6 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at 60% 40%, rgba(20,241,217,0.08) 0%, transparent 60%)" }} />
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-teal mb-6 px-3 py-1 rounded-full border border-brand-teal/30 bg-brand-teal/5">
              Careers
            </span>
            <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-snug lg:leading-relaxed">
              예술과 비즈니스<br />
              <span className="gradient-text-brand">경계를 함께</span><br />
              허무세요.
            </h1>
            <p className="mt-8 text-base md:text-lg text-white/60 font-body leading-loose max-w-2xl">
              아르트레너는 크리에이터 이코노미의 최전선에서 일하는 사람들을 찾습니다. 당신의 전문성이 아티스트의 삶을 바꿉니다.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <div className="glass rounded-full px-4 py-2 text-sm text-white/60 font-body border border-white/10">
                <i className="ri-map-pin-line text-brand-teal mr-2" />서울 강남구
              </div>
              <div className="glass rounded-full px-4 py-2 text-sm text-white/60 font-body border border-white/10">
                <i className="ri-team-line text-brand-purple mr-2" />현재 9명 채용 중
              </div>
              <div className="glass rounded-full px-4 py-2 text-sm text-white/60 font-body border border-white/10">
                <i className="ri-time-line text-brand-orange mr-2" />상시 지원 가능
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 lg:py-32 px-4 md:px-6" style={{ background: "linear-gradient(180deg, #06080F 0%, #0A0B16 100%)" }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14 lg:mb-20">
            <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-orange mb-5 px-3 py-1 rounded-full border border-brand-orange/30 bg-brand-orange/5">
              Why ARTREPRENEUR
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-white leading-snug">우리와 함께하면</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-7">
            {benefits.map((b) => (
              <div key={b.title} className="glass rounded-2xl p-6 lg:p-8 flex flex-col gap-5" style={{ border: `1px solid ${b.color}18` }}>
                <div className="w-11 h-11 flex items-center justify-center rounded-xl" style={{ background: `${b.color}18`, border: `1px solid ${b.color}30` }}>
                  <i className={`${b.icon} text-lg`} style={{ color: b.color }} />
                </div>
                <h3 className="font-display text-base font-bold text-white">{b.title}</h3>
                <p className="text-white/50 text-sm font-body leading-loose">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Positions */}
      <section className="py-20 lg:py-32 px-4 md:px-6 bg-brand-bg">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-14 lg:mb-20">
            <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-purple mb-5 px-3 py-1 rounded-full border border-brand-purple/30 bg-brand-purple/5">
              Open Positions
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-white leading-snug">
              현재 모집 중인 포지션
            </h2>
          </div>

          <div className="flex flex-col gap-4 lg:gap-5">
            {positions.map((pos) => (
              <div
                key={pos.id}
                className="glass rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer"
                style={{ border: openId === pos.id ? `1px solid ${pos.color}40` : "1px solid rgba(255,255,255,0.08)" }}
                onClick={() => setOpenId(openId === pos.id ? null : pos.id)}
              >
                {/* Header row */}
                <div className="flex items-center justify-between p-5 lg:p-7">
                  <div className="flex items-center gap-4 flex-1 min-w-0">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: pos.glow, border: `1px solid ${pos.color}30` }}>
                      <i className="ri-briefcase-line" style={{ color: pos.color }} />
                    </div>
                    <div className="min-w-0">
                      <div className="flex items-center gap-3 flex-wrap">
                        <h3 className="font-display text-base font-bold text-white">{pos.title}</h3>
                        <span className="text-xs font-body px-2 py-0.5 rounded-full" style={{ background: pos.glow, color: pos.color, border: `1px solid ${pos.color}30` }}>{pos.dept}</span>
                      </div>
                      <div className="flex items-center gap-3 mt-1 text-xs text-white/40 font-body flex-wrap">
                        <span><i className="ri-map-pin-2-line mr-1" />{pos.loc}</span>
                        <span><i className="ri-time-line mr-1" />{pos.type}</span>
                        <span><i className="ri-user-line mr-1" />{pos.headcount} 채용</span>
                      </div>
                    </div>
                  </div>
                  <i className={`ri-${openId === pos.id ? "subtract" : "add"}-line text-white/40 text-xl flex-shrink-0 ml-4`} />
                </div>

                {/* Expanded */}
                {openId === pos.id && (
                  <div className="px-5 pb-6 lg:px-7 lg:pb-8 flex flex-col gap-6 border-t border-white/5">
                    <p className="text-sm text-white/60 font-body leading-loose pt-5">{pos.desc}</p>

                    <div className="flex flex-wrap gap-2">
                      {pos.tags.map((t) => (
                        <span key={t} className="px-3 py-1 rounded-full text-xs font-body text-white/60" style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)" }}>{t}</span>
                      ))}
                    </div>

                    <div>
                      <p className="text-xs font-display font-semibold text-white/40 uppercase tracking-wider mb-3">자격 요건</p>
                      <ul className="flex flex-col gap-2">
                        {pos.reqs.map((r) => (
                          <li key={r} className="flex items-start gap-2.5 text-sm text-white/60 font-body">
                            <i className="ri-check-line mt-0.5 flex-shrink-0" style={{ color: pos.color }} />
                            {r}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <a
                      href={`mailto:eunhyun1@naver.com?subject=${encodeURIComponent(`[지원] ${pos.title}`)}`}
                      className="self-start flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-display font-semibold text-white cursor-pointer whitespace-nowrap transition-all duration-300"
                      style={{ background: `linear-gradient(135deg, ${pos.color}, ${pos.color}99)`, boxShadow: `0 0 16px ${pos.glow}` }}
                    >
                      지원하기
                      <i className="ri-arrow-right-line text-xs" />
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 lg:mt-14 text-center glass rounded-2xl p-7 lg:p-9">
            <p className="text-white/60 text-sm font-body leading-relaxed mb-2">원하는 포지션이 없나요?</p>
            <p className="text-white font-display font-semibold text-base mb-5">언제든 열린 지원을 환영합니다.</p>
            <a href="mailto:eunhyun1@naver.com" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-body text-white/70 hover:text-white glass border border-white/15 hover:border-white/30 cursor-pointer whitespace-nowrap transition-all">
              <i className="ri-mail-send-line text-brand-purple" />
              eunhyun1@naver.com
            </a>
          </div>
        </div>
      </section>
    </InnerPageLayout>
  );
}
